// Input methods (doc/20261023-i18n-zh-cn.md §3.9): the Enter that confirms a Chinese input method's candidate is not a
// submit. A form submits on Enter in any of its inputs, so each one holds that Enter back.
import type { KeyboardEvent } from 'react';

/** An input's onKeyDown: an Enter while composing never reaches the form's implicit submit. */
export function holdComposingEnter(event: KeyboardEvent<HTMLElement>): void {
  if (event.key === 'Enter' && event.nativeEvent.isComposing) event.preventDefault();
}
